import React from "react";
import { logJSError, logNewrelicNoticeError, setVzwDLValues } from './../../utilities/logger';
import { libLogger } from "@vz/react-util";
import TileInfo from './TileInfo';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, jsError:false };
  }

  componentDidMount() {
    if (this?.props?.errorcode == '308') {
      this?.props?.history?.push("/")
    }
  }

  componentDidCatch(error, info) {
    if (!this.props.hideError) {
      this.setState({ hasError: true, jsError:true });
    }
    console.log(error, info);
    // libLogger.logJSError(error, info, "RENDER");
    // libLogger.logNewrelicNoticeError(error,"ErrorBoundaryError");
    // logJSError(error, info, "RENDER");
    // logNewrelicNoticeError(error,"ErrorBoundaryError");
  }

  static getDerivedStateFromProps(props, state) {
    if (props.errorcode !== "0" && props.errorcode !== "00") {
      return {hasError : true};
    }
    // else{
    //   return {hasError:false};
    // }
  }

  render() {
   // return this.props.children; //for initial testing avoid err
   

    if (this.state.hasError) {
      
      if (this.props.jsx) {
        return this.props.jsx;
      }
      return (
        <TileInfo 
        history ={this.props.history}
        flowName = {this.props.flowName}
        offerId={this.props.offerId}
        offerName={this.props.offerName}
        isVisible={this.state.hasError}
        isAccordionError = {this.props.accordionError}
          isTrialUnlimited={this.props.isTrialUnlimited}
          htmlMessage={
            this.props.htmlMessage && this.props.htmlMessage != "" && this.props.htmlMessage != "SUCCESS"
              ? this.props.htmlMessage
              : undefined
          }
          htmlSubMessage={
            this.props.htmlSubMessage && this.props.htmlSubMessage != "" && this.props.htmlSubMessage != "SUCCESS"
              ? this.props.htmlSubMessage
              : undefined
          }
          htmlDescMessage={
            this.props.htmlDescMessage && this.props.htmlDescMessage != "" && this.props.htmlDescMessage != "SUCCESS"
              ? this.props.htmlDescMessage
              : this.props.htmlMessage ? "" : undefined
          }
          htmlActionName={
            this.props.htmlActionName && this.props.htmlActionName != "" && this.props.htmlMessage != "SUCCESS"
              ? this.props.htmlActionName
              : undefined
          }
          htmlActionValue={
            this.props.htmlActionValue && this.props.htmlActionValue != "" && this.props.htmlMessage != "SUCCESS"
              ? this.props.htmlActionValue
              : undefined
          }
          htmlHideButton={
            this.props.htmlHideButton ? this.props.htmlHideButton : false
          }
          isPendingOrder={this.props.isPendingOrder ? this.props.isPendingOrder : false}
          isMMPlans={this.props.isMMPlans ? this.props.isMMPlans : false}
          errorcode = {this.props.errorcode}
          jsError = {this.state.jsError}
        />
      )
    }
    return this.props.children;
  }
}
